/**
 * `--hkp-app-h`: the height the phone actually shows, in px. Browsers without `dvh` (Chrome before
 * 108, iOS Safari before 15.4, e.g. older Tecno / Android 6–9 phones) only have `100vh`, which is the
 * height with the address bar hidden; the studio frame then ran past the screen and the sticky
 * Back / Save draft bar ended up off the bottom. CSS uses this first and `dvh` where supported.
 */
export const trackVisibleHeight = (win: Window = window): (() => void) => {
  const set = () => win.document.documentElement.style.setProperty("--hkp-app-h", `${win.innerHeight}px`);
  set();
  win.addEventListener("resize", set);
  win.addEventListener("orientationchange", set);
  return () => {
    win.removeEventListener("resize", set);
    win.removeEventListener("orientationchange", set);
  };
};
